import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import toast from './plugins/toast/';

import { IonicVue } from '@ionic/vue';
import vuex from './plugins/store';
import axios from '@/plugins/axios'
/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

import SignaturePad from "vue3-signature-pad";

const app = createApp(App)
  .use(IonicVue)
  .use(SignaturePad)
  .use(router)
  .use(vuex)
  
router.isReady().then(() => {
	app.config.globalProperties.$baseURL = axios.defaults.baseURL;
	app.config.globalProperties.$toast = toast;
	app.mount('#app');
});